import { createDivIn, createImgIn, createParagraphIn, setElementInnerHTML, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { CA } from '../analytics/Analytics.ts';
import { localizeAnnualToMonthly } from './PriceUtils.ts';
import { doActionIfCanGiftMembership, doActionIfLoggedIn, isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from './StoreUtils.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UICheckoutAjaxEndPoints } from '../ui_checkout/UICheckoutAjaxEndPoints.ts';
import { AnalyticEventValue, AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod } from '../../../../shared/entity_datas/EntityDatas.ts';
import { UIMembershipProductView } from './UIMembershipProductView.ts';
import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { ColonistMembershipType, LobbyImage } from '@colonist/types';
import { ClientUserState } from '../ClientUserState.ts';
import { UIStoreAjaxEndPoints } from './UIStoreAjaxEndPoints.ts';
import { isSubscriptionOverlayVisible } from './subscription_overlay/subscriptionOverlayABTest.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { sendPurchaseSessionStartedAnalytic } from '../analytics/sendPurchaseFunnelAnalytic.ts';
export class UIStoreMembershipProductView extends UIMembershipProductView {
    getDisclaimerKey() {
        var _this_localizedPriceData, _this_localizedPriceData1;
        const annualPrice = this.getMembershipPriceString('annual');
        const context = ((_this_localizedPriceData = this.localizedPriceData) === null || _this_localizedPriceData === void 0 ? void 0 : _this_localizedPriceData.price) != undefined ? 'localized' : '';
        const amount = ((_this_localizedPriceData1 = this.localizedPriceData) === null || _this_localizedPriceData1 === void 0 ? void 0 : _this_localizedPriceData1.price) != undefined ? this.localizedPriceData.displayPrice : annualPrice;
        if (this.membershipProduct.billedAnnually) return {
            key: 'strings:storePage.sections.membership.billing.annually',
            options: {
                context: context,
                amount: amount
            }
        };
        return {
            key: 'strings:storePage.sections.membership.billing.monthly'
        };
    }
    createDefaultAction() {
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendClickAnalytic();
            if (isPurchaseUnavailableOnPlatform()) {
                showUnavailableOnMobilePopup();
                return;
            }
            doActionIfLoggedIn(()=>{
                this.sendToCheckout();
            });
        });
    }
    getMembershipPriceString(requestedPricing = 'monthly') {
        var _this_localizedPriceData;
        if (((_this_localizedPriceData = this.localizedPriceData) === null || _this_localizedPriceData === void 0 ? void 0 : _this_localizedPriceData.price) != undefined) return this.convertLocalizedPriceToMonthly();
        const monthlyPrice = this.membershipProduct.price / 100;
        const isAnnualRequested = requestedPricing == 'annual';
        const price = isAnnualRequested ? monthlyPrice * 12 : monthlyPrice;
        return `${price}`;
    }
    convertLocalizedPriceToMonthly() {
        if (!this.localizedPriceData) return '';
        if (this.localizedPriceData.price == null) return '';
        const isBilledAnnually = this.membershipProduct.billedAnnually;
        if (isBilledAnnually) return UIStoreMembershipProductView.formatAnnualAmountAsMonthly(this.localizedPriceData.price);
        return UIStoreMembershipProductView.formatLocalizedAmount(this.localizedPriceData.price);
    }
    getLocalizedMonthlyDisplayPrice() {
        var _this_localizedPriceData;
        if (((_this_localizedPriceData = this.localizedPriceData) === null || _this_localizedPriceData === void 0 ? void 0 : _this_localizedPriceData.price) == null) return undefined;
        if (this.membershipProduct.billedAnnually) return localizeAnnualToMonthly(this.localizedPriceData);
        return this.localizedPriceData.displayPrice;
    }
    static formatLocalizedAmount(rawAmount) {
        const cents = Math.round(rawAmount * 100);
        return UIStoreMembershipProductView.formatCentsAsPrice(cents);
    }
    static formatAnnualAmountAsMonthly(rawAnnualAmount) {
        const annualCents = Math.round(rawAnnualAmount * 100);
        const monthlyCents = Math.floor(annualCents / 12);
        return UIStoreMembershipProductView.formatCentsAsPrice(monthlyCents);
    }
    static formatCentsAsPrice(cents) {
        const amount = Number((cents / 100).toFixed(2));
        const isWholeNumber = amount % 1 === 0;
        if (isWholeNumber) return String(amount);
        return amount.toFixed(2);
    }
    showStrikeThroughPrice() {
        var _this_localizedMonthlyPriceData, _this_localizedMonthlyPriceData1;
        const monthlyPrice = ColonistMembershipProduct.getMonthlyPriceOfAnnualMembership(this.getColonistMembershipType());
        if (monthlyPrice == undefined) return;
        const localizedMonthlyPrice = (_this_localizedMonthlyPriceData = this.localizedMonthlyPriceData) === null || _this_localizedMonthlyPriceData === void 0 ? void 0 : _this_localizedMonthlyPriceData.price;
        const hasLocalizedMonthlyPrice = localizedMonthlyPrice != undefined;
        const context = hasLocalizedMonthlyPrice ? 'strikethroughLocalized' : 'strikethrough';
        const amount = hasLocalizedMonthlyPrice ? (_this_localizedMonthlyPriceData1 = this.localizedMonthlyPriceData) === null || _this_localizedMonthlyPriceData1 === void 0 ? void 0 : _this_localizedMonthlyPriceData1.displayPrice : `${monthlyPrice}`;
        const strikethourghPrice = createParagraphIn(this.priceDiv, {
            key: 'strings:storePage.sections.membership.billing.paidMonthly',
            options: {
                context: context,
                amount: amount
            }
        }, 'strikethrough-price', '');
        this.priceDiv.insertBefore(strikethourghPrice, this.priceDiv.firstChild);
    }
    sendToCheckout() {
        if (isPurchaseUnavailableOnPlatform()) {
            showUnavailableOnMobilePopup();
            return;
        }
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.membershipProduct.storeProductType,
            productType: this.membershipProduct.type,
            method: 'stripeCheckout'
        });
        const shouldOpenCheckoutInNewTab = isSubscriptionOverlayVisible();
        if (this.membershipProduct.oneTimePurchaseType != null) {
            navigateToPage(UIAPIEndpoints.checkoutOneTimePurchaseUrl(this.membershipProduct.oneTimePurchaseType), shouldOpenCheckoutInNewTab);
            return;
        }
        navigateToPage(UIAPIEndpoints.checkoutMembershipUrl(this.getColonistMembershipType()), shouldOpenCheckoutInNewTab);
    }
    static getMembershipAnalyticValue(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.PlusMonthly:
                return AnalyticEventValue.StoreMembershipPlusMonthly;
            case ColonistMembershipType.PremiumMonthly:
                return AnalyticEventValue.StoreMembershipPremiumMonthly;
            case ColonistMembershipType.EliteMonthly:
                return AnalyticEventValue.StoreMembershipEliteMonthly;
            case ColonistMembershipType.PlusYearly:
                return AnalyticEventValue.StoreMembershipPlusYearly;
            case ColonistMembershipType.PremiumYearly:
                return AnalyticEventValue.StoreMembershipPremiumYearly;
            case ColonistMembershipType.EliteYearly:
                return AnalyticEventValue.StoreMembershipEliteYearly;
            case ColonistMembershipType.Holiday2023AllAccessPass:
                return AnalyticEventValue.StoreMembershipHoliday2023AllAccessPass;
        }
    }
    sendClickAnalytic() {
        const clickAnalytic = UIStoreMembershipProductView.getMembershipAnalyticValue(this.getColonistMembershipType());
        const eventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: clickAnalytic,
            stringValue: this.storeState.clickAnalyticSource
        };
        void CA.sendAnalyticEvent(eventData);
    }
    getColonistMembershipType() {
        if (this.storeState.membershipToggleYearlyActive) {
            if (this.membershipProduct.type == ColonistMembershipType.PlusMonthly) return ColonistMembershipType.PlusYearly;
            if (this.membershipProduct.type == ColonistMembershipType.PremiumMonthly) return ColonistMembershipType.PremiumYearly;
            if (this.membershipProduct.type == ColonistMembershipType.EliteMonthly) return ColonistMembershipType.EliteYearly;
        }
        return this.membershipProduct.type;
    }
    changeToDowngradeButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.downgrade'
        });
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendClickAnalytic();
            doActionIfLoggedIn(()=>{
                this.manageSubscription();
            });
        });
    }
    changeToManageButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.manage'
        });
        this.subscribeButton.classList.add('button_owned');
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendClickAnalytic();
            doActionIfLoggedIn(()=>{
                this.manageSubscription();
            });
        });
    }
    changeToUpgradeButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.upgrade'
        });
        this.subscribeButton.classList.add('button_upgrade');
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendClickAnalytic();
            doActionIfLoggedIn(()=>{
                this.manageSubscription();
            // TODO Goku: Make this one go to this screen https://i.imgur.com/CA860ea.png instead of this https://i.imgur.com/hzz9Laa.png
            });
        });
    }
    changeToGoAnnualButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.goAnnual'
        });
        this.subscribeButton.classList.add('button_upgrade');
        setElementOnClick(this.productDiv, ()=>{
            AudioManager.play(AudioType.Click);
            this.sendClickAnalytic();
            doActionIfLoggedIn(()=>{
                this.manageSubscription();
            // TODO Goku: Make this one go to this screen https://i.imgur.com/CA860ea.png instead of this https://i.imgur.com/hzz9Laa.png
            });
        });
    }
    changeToOwnedButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:popups.owned.title'
        });
        this.subscribeButton.classList.add('button_owned');
        setElementOnClick(this.productDiv, ()=>undefined);
    }
    changeToCancelButton() {
        this.removeButtonStyling();
        setElementInnerHTML(this.subscribeButtonText, {
            key: 'strings:storePage.sections.membership.action.cancel'
        });
        this.subscribeButton.classList.add('button_owned');
        setElementOnClick(this.productDiv, ()=>UIStoreMembershipProductView.cancelGiftedMembership());
    }
    removeButton() {
        this.subscribeButton.classList.add('hidden');
        setElementOnClick(this.productDiv, ()=>undefined);
    }
    removeButtonStyling() {
        if (this.subscribeButton.classList.contains('button_upgrade')) this.subscribeButton.classList.remove('button_upgrade');
        if (this.subscribeButton.classList.contains('button_owned')) this.subscribeButton.classList.remove('button_owned');
    }
    // eslint-disable-next-line class-methods-use-this
    manageSubscription() {
        var _ClientUserState_userState;
        const paymentMethod = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.membershipPaymentMethod;
        if (paymentMethod == PaymentMethod.Discord) {
            UIStoreMembershipProductView.createManageSubscriptionOnDiscordPopup();
            return;
        }
        if (paymentMethod == PaymentMethod.Apple) {
            UIStoreMembershipProductView.showManageSubscriptionPopup({
                key: 'strings:storePage.manageMembership.body',
                options: {
                    context: 'updateOnAppStore'
                }
            });
            return;
        }
        if (paymentMethod == PaymentMethod.Android) {
            UIStoreMembershipProductView.showManageSubscriptionPopup({
                key: 'strings:storePage.manageMembership.body',
                options: {
                    context: 'updateOnGooglePlay'
                }
            });
            return;
        }
        void UICheckoutAjaxEndPoints.executeStripeCustomerPortalSession();
    }
    static showManageSubscriptionPopup(body) {
        const popupTitle = {
            key: 'strings:storePage.manageMembership.title'
        };
        showSimpleDialog({
            title: popupTitle,
            body: body
        });
    }
    static createManageSubscriptionOnDiscordPopup() {
        const popupBody = UIStoreMembershipProductView.getManageSubscriptionOnDiscordPopupBody();
        UIStoreMembershipProductView.showManageSubscriptionPopup(popupBody);
    }
    static getManageSubscriptionOnDiscordPopupBody() {
        var _ClientUserState_userState;
        const discordMembership = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.getCurrentMembership();
        if (discordMembership == undefined) throw new Error('Membership not found');
        const hasDiscordAnnualMembership = ColonistMembershipProduct.isAnnualMembership(discordMembership.type);
        if (hasDiscordAnnualMembership) return {
            key: 'strings:storePage.manageMembership.body',
            options: {
                context: 'waitForExpiration'
            }
        };
        return {
            key: 'strings:storePage.manageMembership.body',
            options: {
                context: 'updateOnDiscord'
            }
        };
    }
    static async cancelGiftedMembership() {
        showSimpleDialog({
            title: {
                key: 'strings:storePage.sections.membership.cancelConfirmation.title'
            },
            body: {
                key: 'strings:storePage.sections.membership.cancelConfirmation.body'
            },
            onConfirm: async ()=>await UIStoreAjaxEndPoints.cancelGiftedMembership(),
            showCancelBtn: true
        });
    }
    constructor(container, storeState, membershipProduct, giftOverlay, localizedPriceData, localizedMonthlyPriceData){
        super(container, membershipProduct);
        this.storeState = storeState;
        this.localizedPriceData = localizedPriceData;
        this.localizedMonthlyPriceData = localizedMonthlyPriceData;
        this.createDefaultAction();
        this.priceDiv = createDivIn(this.productDiv, 'store-page-membership-price', '');
        const localizedMonthlyDisplayPrice = this.getLocalizedMonthlyDisplayPrice();
        if (localizedMonthlyDisplayPrice != undefined) {
            this.membershipPrice = createParagraphIn(this.priceDiv, {
                key: 'strings:storePage.sections.membership.billing.paidMonthly',
                options: {
                    context: 'localized',
                    amount: localizedMonthlyDisplayPrice
                }
            }, '', '');
        } else {
            const price = this.getMembershipPriceString();
            this.membershipPrice = createParagraphIn(this.priceDiv, {
                key: 'strings:storePage.sections.membership.billing.paidMonthly',
                options: {
                    context: 'biggerPrice',
                    amount: price,
                    currency: '$'
                }
            }, '', '');
        }
        const shouldShowStrikethroughPrice = membershipProduct.billedAnnually;
        if (shouldShowStrikethroughPrice) this.showStrikeThroughPrice();
        this.disclaimerText = createParagraphIn(this.productDiv, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'store_page_membership_disclaimer', '');
        const disclaimerKey = this.getDisclaimerKey();
        setElementInnerHTML(this.disclaimerText, disclaimerKey);
        this.buttonsContainer = createDivIn(this.productDiv, 'store-button-membership-container');
        this.subscribeButton = createDivIn(this.buttonsContainer, 'store-button-membership');
        this.subscribeButtonText = createParagraphIn(this.subscribeButton, {
            key: 'strings:storePage.sections.membership.action.subscribe'
        }, '', '');
        if (!giftOverlay) return;
        this.giftButton = createDivIn(this.buttonsContainer, 'store-button-gift');
        createImgIn(this.giftButton, LobbyImage.StoreGiftMembership);
        const giftButtonClickEventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.GiftMembershipOverlay,
            floatValue: GiftMembershipMethod.Store
        };
        setElementOnClick(this.giftButton, ()=>{
            void CA.sendAnalyticEvent(giftButtonClickEventData);
            if (isPurchaseUnavailableOnPlatform()) {
                showUnavailableOnMobilePopup();
                return;
            }
            doActionIfCanGiftMembership(()=>{
                giftOverlay.show();
                giftOverlay.reorderPages(false);
                giftOverlay.selectGiftTier(this.membershipProduct.type);
            });
        }, false, true);
    }
}
